import {getRouteApi} from "@tanstack/react-router";

export const offersRouteApi = getRouteApi("/_app/sales/offers/");
